import { Component, Input } from '@angular/core';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-navbar-menu',
  templateUrl: './navbar-menu.component.html',
  styleUrls: ['./navbar-menu.component.scss'],
})
export class NavbarMenuComponent {
  @Input() current_nav_item?: NavigationItem;
  @Input() navbar_status?: NavbarStatus;
  nav_items: Map<string, NavigationItem>;
  open_navbar_status: NavbarStatus = NavbarStatus.open;
  closed_navbar_status: NavbarStatus = NavbarStatus.closed;

  constructor(private navigation_service: NavigationService) {
    this.nav_items = this.navigation_service.navigation_set.nav_items;
  }

  onMenuItemClick(item: NavigationItem): void {
    this.navigation_service.toGenericPath(item.path || '');
  }

  getNavItems(): NavigationItem[] {
    return [...this.nav_items.values()];
  }

  getCurrentItemClass(item: NavigationItem): { [key: string]: boolean } {
    return {
      'sp-navbar-menu__selected-item': item.label == this.current_nav_item?.label,
      'sp-navbar-menu__not-selected-item': item.label != this.current_nav_item?.label,
    };
  }
}
